import { colors } from '@/theme/colors';

export type DiamondIconProps = {
  size?: { width: number; height: number };
};

export default function Diamond({ size = { width: 16, height: 16 } }: DiamondIconProps) {
  return (
    <svg
      width={`${size.width}`}
      height={`${size.height}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2216 2.88125C12.1401 2.77258 12.0344 2.68438 11.9129 2.62363C11.7914 2.56288 11.6574 2.53125 11.5216 2.53125H4.52156C4.38572 2.53125 4.25175 2.56288 4.13025 2.62363C4.00875 2.68438 3.90307 2.77258 3.82156 2.88125L1.87498 5.47767C1.75685 5.63528 1.69534 5.82813 1.70043 6.02503C1.70551 6.22193 1.77687 6.41136 1.90298 6.56267L7.35015 13.1543C7.43227 13.2524 7.5349 13.3313 7.6508 13.3854C7.76671 13.4395 7.89307 13.4675 8.02098 13.4675C8.14889 13.4675 8.27525 13.4395 8.39115 13.3854C8.50706 13.3313 8.60969 13.2524 8.69181 13.1543L14.139 6.56267C14.2651 6.41136 14.3365 6.22193 14.3415 6.02503C14.3466 5.82813 14.2851 5.63528 14.167 5.47767L12.2216 2.88125Z"
        stroke={colors.neutral100}
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.12024 2.62866L8.02157 13.4687"
        stroke={colors.neutral100}
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9224 2.62866L8.02161 13.4687"
        stroke={colors.neutral100}
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.69885 6.03125H14.3414"
        stroke={colors.neutral100}
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.39661 6.03125L8.02161 2.53125L10.6466 6.03125"
        stroke={colors.neutral100}
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
